import { render, staticRenderFns } from "./TipoProblemaList.vue?vue&type=template&id=9ba27116"
import script from "./TipoProblemaList.vue?vue&type=script&lang=js"
export * from "./TipoProblemaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports